var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['lr-modal', {'hide': !_vm.show}]},[_c('div',{staticClass:"lr-box"},[_c('div',{staticClass:"lr-alert-msg",domProps:{"innerHTML":_vm._s(_vm.message)}}),_vm._v(" "),_c('a',{staticClass:"button cta small right block",on:{"click":function($event){_vm.show = false}}},[_vm._v("\n      Close\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b487bea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/App/Alert.vue
// module id = 857
// module chunks = 0